import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space, Modal } from "antd";
import { SearchOutlined, DeleteOutlined, PlusOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import { ModalCadLotes } from "./components/lotesCadastro";
import http from "../../../services/http";
import dayjs from "dayjs";

export const UniformesLotesFaturamento = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // FILTRO STATUS
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarLotes();
  }, []);

  // LISTAR
  const listarLotes = async () => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_pedidos_recebimento/listar_lotes_faturamento`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarLote = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_pedidos_recebimento/deletar_lote`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarLotes();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Nº",
      dataIndex: "id",
      sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
    },
    {
      title: "Data",
      dataIndex: "data",
      render: (_, e) => dayjs(e?.data_lancamento).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a?.data_lancamento).format("DD/MM/YYYY")?.localeCompare(dayjs(b?.data_lancamento).format("DD/MM/YYYY")),
    },
    {
      title: "Ações",
      width: 80,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Excluir">
            <Button
              loading={loading}
              icon={<DeleteOutlined />}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    deletarLote(e.id);
                  },
                });
              }}
            />
          </Tooltip>
        </Space.Compact>
      ),
      dataIndex: "acoes",
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.id?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val?.data_lancamento).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // CLOSE MODAL
  const handleModalClose = () => {
    setShowModal(false);
    listarLotes();
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <ModalCadLotes showModal={showModal} onClose={handleModalClose} />
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Uniformes Lotes Faturamento"
              subtitle="Gerenciar Lotes Para Faturamento"
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowModal(true)} loading={loading}>
                  Criar Lote
                </Button>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
